React = require 'react'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class HomeBoardSectionLinksItem extends React.Component
  displayName: 'HomeBoardSectionLinksItem'

  render: t.renderable ->
    { url, onClick, icon, text, showBackground } = @props

    t.div '.home-board-section-item', =>
      t.a '.home-board-link', {
        href: if url then url else '#'
        onClick: onClick
      }, ->
        t.span ".icon-sm.icon-#{icon}.home-board-link-icon", { class: t.classify('with-background': showBackground) }
        t.span '.home-board-link-text', ->
          t.format text



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-section-links-item.coffee